class BillableServiceItem {
    public BillableServiceId: string;
    public NameFr: string;
    public NameEn: string;
    public NameEs: string;
    public Price: number;
    public Number: string;
    public HasQST: boolean;
    public HasGST: boolean;
    public HasHST: boolean;
    public HasGenericTax: boolean;
    public CostCenterId: string;
    public LastUpdateDate: Date;
    public NameCostCenter: string;
    public CodeCostCenter: string;
    public SiteId: string;
    public CreatedBy: string;
    public CreateByEmployeeId: string;
    public ModifiedByEmployeeId: string;
    public LastUpdatedBy: string;
    // todo: map this to backend service that returns services on search
    public IsFromServiceList: boolean;
    public TotalRows: number;
    // public Name : string; // related to user current language

    constructor() {
        this.BillableServiceId = "";
        this.NameFr = "";
        this.NameEn = "";
        this.NameEs = "";
        this.Price = 0;
        this.Number = "";
        this.HasQST = false;
        this.HasGST = false;
        this.HasHST = false;
        this.CostCenterId = "";
        this.NameCostCenter = "";
        this.CodeCostCenter = "";
        this.SiteId = "";
        this.CreatedBy = "";
        this.CreateByEmployeeId = "";
        this.ModifiedByEmployeeId = "";
        this.LastUpdatedBy = "";
    }
}

export { BillableServiceItem };
